import React from 'react';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  Fade,
  Paper
} from '@mui/material';
import { Palette } from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

const themeColors = {
  pastelGreen: '#66BB6A',
  softBlue: '#42A5F5',
  warmPink: '#EC407A',
  midnight: '#64FFDA',
};

export default function ThemeSelector() {
  const { currentTheme, changeTheme, availableThemes, themeNames } = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleThemeChange = (themeName) => {
    changeTheme(themeName);
    handleClose();
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            transform: 'scale(1.05)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <Palette />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            mt: 1,
          },
        }}
      >
        {availableThemes.map((themeName) => (
          <MenuItem
            key={themeName}
            onClick={() => handleThemeChange(themeName)}
            sx={{
              borderRadius: '12px',
              margin: '4px 8px',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                transform: 'translateX(4px)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            <Avatar
              sx={{
                width: 24,
                height: 24,
                backgroundColor: themeColors[themeName],
                border: currentTheme === themeName ? '3px solid' : '1px solid',
                borderColor: currentTheme === themeName ? 'primary.main' : 'grey.300',
              }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: currentTheme === themeName ? 600 : 400,
                color: currentTheme === themeName ? 'primary.main' : 'text.primary',
              }}
            >
              {themeNames[themeName]}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}